/**
 * Guards a once-per-session side effect: the `stream_rendered` funnel milestone.
 *
 * `connectToBroadcast` re-registers the peer-stream callback on every reconnect,
 * so the raw technical "remote stream received" event fires repeatedly. The
 * conversion milestone, however, must be counted at most once per session (a
 * reconnect is not a new conversion, and its `pageLoadTime`-based duration would
 * be stale). This gate encapsulates that decision so the coordinator stays thin
 * and the behaviour is independently testable.
 */
export class StreamRenderedGate {
  private emitted = false;

  /**
   * Returns `true` exactly once per session — on the first call since
   * construction or the last {@link reset} — and `false` on every call after.
   */
  shouldEmit(): boolean {
    if (this.emitted) {
      return false;
    }
    this.emitted = true;
    return true;
  }

  /**
   * Begins a new session. The next {@link shouldEmit} call returns `true` again.
   */
  reset(): void {
    this.emitted = false;
  }
}
